export default {
  regionSelector: {
    chooseADisasterRegion: 'Sélectionnez une région sinistrée',
    lastUpdate: 'Dernière mise à jour'
  }
}
